import React from 'react';
import type { ColDef, ValueFormatterParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getCrcies, saveCrciesBatch } from '../../api/crcy';
import type { Crcy } from '../../types/Crcy';
import { t } from '../../i18n/t';

const crcyColumnDefs: ColDef<Crcy>[] = [
  {
    field: 'crcyId',
    headerName: t('crcy.columns.crcyId'),
    width: 80,
    // IDENTITY PK assigned by the server — read-only always (even on Add).
    editable: false,
    cellDataType: 'number',
    sort: 'asc',
    valueFormatter: (p: ValueFormatterParams<Crcy>) => {
      const isAdded =
        (p.data as { __status?: string } | undefined)?.__status === 'added';
      if (isAdded) return '';
      return p.value == null ? '' : String(p.value);
    },
  },
  {
    field: 'crcyName',
    headerName: t('crcy.columns.crcyName'),
    flex: 1,
    editable: true,
  },
  {
    field: 'symbol',
    headerName: t('crcy.columns.symbol'),
    flex: 1,
    editable: true,
  },
  {
    field: 'crcyId4Isa',
    headerName: t('crcy.columns.crcyId4Isa'),
    width: 140,
    editable: true,
    cellDataType: 'number',
  },
  {
    field: 'assetId',
    headerName: t('crcy.columns.assetId'),
    width: 140,
    editable: true,
    cellDataType: 'number',
  },
  {
    field: 'leumiCrcyId',
    headerName: t('crcy.columns.leumiCrcyId'),
    width: 140,
    editable: true,
    cellDataType: 'number',
  },
  {
    field: 'interestAssetId',
    headerName: t('crcy.columns.interestAssetId'),
    width: 140,
    editable: true,
    cellDataType: 'number',
  },
  {
    field: 'crcyName4Isa',
    headerName: t('crcy.columns.crcyName4Isa'),
    flex: 1,
    editable: true,
  },
  {
    field: 'level3CodeId',
    headerName: t('crcy.columns.level3CodeId'),
    width: 130,
    editable: true,
  },
  {
    field: 'isDirectILSBfix',
    headerName: t('crcy.columns.isDirectILSBfix'),
    width: 130,
    editable: true,
    cellDataType: 'boolean',
  },
];

const newCrcyDefaults = (): Partial<Crcy> => ({
  crcyId: 0,
  crcyName: '',
  symbol: null,
  crcyId4Isa: null,
  crcyName4Isa: null,
  level3CodeId: null,
  isDirectILSBfix: null,
  assetId: null,
  leumiCrcyId: null,
  interestAssetId: null,
});

export function CrcyPage() {
  return (
    <LopCrudPage<Crcy>
      resourceCode="crcy"
      titleKey="crcy.pageTitle"
      idField="crcyId"
      getRows={getCrcies}
      saveBatch={(added, modified, deletedIds) =>
        saveCrciesBatch(added, modified, deletedIds as number[])
      }
      columnDefs={crcyColumnDefs}
      newRowDefaults={newCrcyDefaults}
    />
  );
}
